module.exports = __webpack_public_path__ + "static/media/fly0041.cd22a414.webp";